import { useState } from "react";
import api, { formatApiError } from "../api";
import { useAuth } from "../context/AuthContext";
import { StatusBadge } from "../components/StatusBadge";
import { toast } from "sonner";

export default function MyStatus() {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 4) return toast.error("A nova senha deve ter ao menos 4 caracteres");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Senha atualizada");
      setCurrent("");
      setNext("");
    } catch (e2) {
      toast.error(formatApiError(e2));
    } finally {
      setBusy(false);
    }
  };

  if (!user) return null;

  return (
    <div className="max-w-xl">
      <div className="mb-6">
        <div className="text-xs uppercase tracking-[0.25em] text-gray-500">Perfil</div>
        <h1 className="font-display text-3xl sm:text-4xl font-medium tracking-tight">Meu status</h1>
      </div>

      <div className="rounded-2xl border border-gray-200 bg-white p-5">
        <div className="grid grid-cols-2 gap-4 text-sm">
          <Info label="Nome" value={user.name} />
          <Info label="E-mail" value={user.email} />
          <Info label="Status" value={<StatusBadge status={user.status} />} />
          <Info label="Papel" value="Profissional" />
        </div>
      </div>

      <form onSubmit={submit} className="mt-6 rounded-2xl border border-gray-200 bg-white p-5">
        <h2 className="mb-4 font-display text-xl font-semibold tracking-tight">Alterar senha</h2>
        <div className="space-y-4">
          <div>
            <label className="mb-2 block text-xs font-medium uppercase tracking-wider text-gray-500">Senha atual</label>
            <input
              data-testid="input-cur-pw"
              type="password"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              className="w-full rounded-lg border border-gray-200 px-3 py-2.5 outline-none focus:border-black"
            />
          </div>
          <div>
            <label className="mb-2 block text-xs font-medium uppercase tracking-wider text-gray-500">Nova senha</label>
            <input
              data-testid="input-new-pw"
              type="password"
              value={next}
              onChange={(e) => setNext(e.target.value)}
              className="w-full rounded-lg border border-gray-200 px-3 py-2.5 outline-none focus:border-black"
            />
          </div>
          <button
            data-testid="btn-change-pw"
            disabled={busy}
            className="w-full rounded-full bg-black py-3 text-sm font-semibold uppercase tracking-widest text-white disabled:opacity-50"
          >
            {busy ? "Salvando…" : "Salvar nova senha"}
          </button>
        </div>
      </form>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div>
      <div className="text-[11px] uppercase tracking-widest text-gray-500">{label}</div>
      <div className="font-medium">{value}</div>
    </div>
  );
}
